import React from "react";

type TProps = {
  width?: string;
  height?: string;
  color?: string;
  className?: string;
};
export const Logo = ({
  color = "#301B3A",
  height = "32",
  width = "99",
  className,
}: TProps) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 99 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M92.8375 31.98C89.5265 31.98 87.3125 29.7461 87.3125 26.4151C87.3125 23.2038 89.6262 20.8701 92.8176 20.8701C96.368 20.8701 98.7415 23.7623 98.1232 27.2927H90.8429C91.0225 28.6491 91.6607 29.3272 92.7578 29.3272C93.7152 29.3272 94.3534 28.9283 94.6526 28.1504H98.0634C97.4052 30.6038 95.5103 31.98 92.8375 31.98ZM92.7378 23.3833C91.7206 23.3833 91.1222 23.9617 90.8828 25.1585H94.4731C94.4332 24.0814 93.7551 23.3833 92.7378 23.3833Z"
        fill={color}
      />
      <path
        d="M87.18 28.4496V31.4215C86.4221 31.8404 85.704 32 84.7466 32C82.3331 32 80.917 30.5639 80.917 28.1105V24.0415H78.9224V21.0696H80.917V17.9181H84.3277V21.0696H87.2598V24.0415H84.3277V27.3127C84.3277 28.3499 84.7665 28.8286 85.704 28.8286C86.2625 28.8286 86.801 28.6889 87.18 28.4496Z"
        fill={color}
      />
      <path
        d="M75.8944 31.8005V30.7633C75.1364 31.621 74.1989 32 72.8227 32C70.5887 32 69.0928 30.6636 69.0928 28.6291C69.0928 26.5348 70.7882 25.3979 73.8599 25.3979C74.4383 25.3979 74.9768 25.4377 75.4356 25.5175V24.9989C75.4356 24.0615 74.8971 23.5429 73.9396 23.5429C73.0022 23.5429 72.4437 24.0615 72.324 24.9989H69.2523C69.4518 22.5057 71.3068 20.8701 73.9596 20.8701C76.9116 20.8701 78.6469 22.4658 78.6469 25.1784V31.8005H75.8944ZM72.3041 28.5294C72.3041 29.2275 72.7828 29.6463 73.6205 29.6463C74.7574 29.6463 75.4356 29.1078 75.4356 28.2302V27.552C74.917 27.4523 74.5181 27.4124 74.0793 27.4124C72.9224 27.4124 72.3041 27.7914 72.3041 28.5294Z"
        fill={color}
      />
      <path
        d="M58.0772 31.8006L55.0055 23.5429V31.8006H51.5947V17.4793H56.0427L59.6529 27.193L63.2432 17.4793H67.6911V31.8006H64.2804V23.4432L61.1887 31.8006H58.0772Z"
        fill={color}
      />
      <path
        d="M90.9674 15.3584C87.6564 15.3584 85.4424 13.1244 85.4424 9.79346C85.4424 6.58215 87.7561 4.24847 90.9475 4.24847C94.4979 4.24847 96.8714 7.14064 96.2531 10.6711H88.9728C89.1523 12.0274 89.7906 12.7056 90.8876 12.7056C91.845 12.7056 92.4833 12.3067 92.7825 11.5288H96.1933C95.535 13.9821 93.6402 15.3584 90.9674 15.3584ZM90.8677 6.76167C89.8504 6.76167 89.2521 7.3401 89.0127 8.53686H92.603C92.5631 7.45978 91.8849 6.76167 90.8677 6.76167Z"
        fill={color}
      />
      <path
        d="M85.0718 11.5288C85.0718 13.9023 83.3165 15.3783 80.0853 15.3783C76.854 15.3783 75.0988 13.8624 74.8794 11.3891H78.1505C78.1505 12.2867 78.9683 12.8651 80.1451 12.8651C80.923 12.8651 81.6211 12.6856 81.6211 12.1271C81.6211 11.6484 81.2621 11.449 80.5241 11.3094L78.4098 10.9304C76.5349 10.5913 75.3382 9.51421 75.3382 7.77891C75.3382 5.70453 77.0934 4.24847 79.9058 4.24847C82.7182 4.24847 84.6729 5.74442 84.8723 8.13794H81.6012C81.5214 7.28026 80.8632 6.76167 79.9257 6.76167C79.1279 6.76167 78.6093 6.98107 78.6093 7.45978C78.6093 7.91853 78.9484 8.05816 79.6265 8.17783L81.9004 8.5967C83.9748 8.97567 85.0718 9.99292 85.0718 11.5288Z"
        fill={color}
      />
      <path
        d="M74.3769 1.95471C74.3769 3.07168 73.4793 3.88947 72.1828 3.88947C70.8863 3.88947 69.9888 3.07168 69.9888 1.95471C69.9888 0.817785 70.8863 0 72.1828 0C73.4793 0 74.3769 0.817785 74.3769 1.95471ZM73.9181 15.1789H70.5074V4.44795H73.9181V15.1789Z"
        fill={color}
      />
      <path
        d="M62.4256 15.1789L60.0919 6.26303L57.7582 15.1789H53.9485L50.3184 0.857666H54.0084L55.9431 9.39455L58.217 0.857666H62.0267L64.2207 9.43444L66.1754 0.857666H69.8654L66.2153 15.1789H62.4256Z"
        fill={color}
      />
      <path
        d="M8.31396 24.3499V4.25637C8.31396 3.40274 9.00598 2.71072 9.85962 2.71072H34.5902C35.4438 2.71072 36.1358 3.40273 36.1358 4.25637V24.3499C36.1358 25.2036 35.4438 25.8956 34.5902 25.8956H28.9227C28.5883 25.8956 28.2629 26.0041 27.9953 26.2047L23.1523 29.837C22.6027 30.2492 21.8471 30.2492 21.2975 29.837L16.4544 26.2047C16.1869 26.0041 15.8615 25.8956 15.527 25.8956H9.85962C9.00598 25.8956 8.31396 25.2036 8.31396 24.3499Z"
        stroke="#B058D9"
        strokeWidth="3.2"
      />
      <circle cx="16.0425" cy="18.1673" r="3.09132" fill="#7B21A6" />
      <circle cx="28.4077" cy="18.1673" r="3.09132" fill="#7B21A6" />
      <g filter="url(#filter0_di_87_58)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.2407 7.3057C13.2139 6.92734 10.4187 6.36444 8.12542 5.6306C5.78994 4.88325 4.15058 4.01284 3.26274 3.125L1 5.38774C2.43065 6.81839 4.65543 7.88005 7.15014 8.67836C9.68708 9.49018 12.6881 10.0865 15.8438 10.481C17.8945 10.7373 19.0448 11.6109 19.706 12.4971C20.3984 13.4251 20.6204 14.4599 20.6249 15.0577C20.6248 15.0638 20.6248 15.0699 20.6248 15.076C20.6248 15.9597 21.3412 16.676 22.2248 16.676C22.5303 16.676 22.8158 16.5904 23.0587 16.4419C23.5182 16.1607 23.8249 15.6542 23.8249 15.076C23.8249 15.0699 23.8249 15.0638 23.8249 15.0577C23.8294 14.4599 24.0513 13.4252 24.7437 12.4972C25.4049 11.611 26.5553 10.7374 28.6059 10.4811C31.7617 10.0866 34.7627 9.49024 37.2996 8.67842C39.7943 7.88011 42.0191 6.81845 43.4498 5.3878L41.187 3.12506C40.2992 4.0129 38.6598 4.88331 36.3243 5.63066C34.0311 6.3645 31.2359 6.9274 28.209 7.30576C25.3504 7.66309 23.4221 8.95045 22.2249 10.5226C21.0277 8.95042 19.0994 7.66303 16.2407 7.3057Z"
          fill="#B058D9"
        />
      </g>
      <defs>
        <filter
          id="filter0_di_87_58"
          x="0"
          y="3.125"
          width="44.4497"
          height="15.551"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_87_58"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_87_58"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_87_58"
          />
        </filter>
      </defs>
    </svg>
  );
};
